import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//map library
import { AgmCoreModule } from '@agm/core/';

//chart
import { ChartModule } from 'angular2-highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';
import * as highchart from 'highcharts'

//graphs
import { GraphComponent } from './graph.component';
import { ColumnChartComponent } from './column-chart/column-chart.component';
import { HistogramComponent } from './histogram/histogram.component';
import { SplineChartComponent } from './spline-chart/spline-chart.component';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { HeatMapComponent } from './heat-map/heat-map.component';
import { CountMapComponent } from './count-map/count-map.component';
import { TableChartComponent } from './table-chart/table-chart.component';
import { PublicGraphComponent } from './public-graph/public-graph.component';
import { SiteMapComponent } from './site-map/site-map.component';
import { VisualMapComponent } from './visual-map/visual-map.component';
import { TrendMapComponent } from './trend-map/trend-map.component';
import { PerformerMapComponent } from './performer-map/performer-map.component';
import { GeoMapComponent } from './geo-map/geo-map.component';
import { CompareTableComponent } from './compare-table/compare-table.component';
import { SandboxGraphComponent } from './sandbox-graph/sandbox-graph.component';
import { StaticLayoutMapComponent } from './static-layout-map/static-layout-map.component';
import { RichTextEditorComponent } from './richtext-editor/richtext-editor.component';
import { CompareDateTableComponent } from './comparedate-table/comparedate-table.component';

const graphs = [GraphComponent, ColumnChartComponent, HistogramComponent, SplineChartComponent,
  PieChartComponent, HeatMapComponent, CountMapComponent, TableChartComponent, CompareDateTableComponent,
  PublicGraphComponent, SiteMapComponent, VisualMapComponent, TrendMapComponent, PerformerMapComponent, GeoMapComponent, CompareTableComponent, SandboxGraphComponent,StaticLayoutMapComponent,RichTextEditorComponent];


import { WidgetHelperService } from './widget-helper.service';

export function highchartsFactory() {
  const hc = require('highcharts');
  const hb=require('highcharts/modules/boost');
  const dd = require('highcharts/modules/exporting');
  const nd = require('highcharts/modules/no-data-to-display');
  const hm = require('highcharts/modules/heatmap');
  dd(hc);
  nd(hc);
  hm(hc);
  // hb(hc);

  hc.setOptions({
    boost: {
      useGPUTranslations: true,
      allowForce:true,      
      seriesThreshold: 200
  },
    lang: {
      thousandsSep: ','
    }
  });
  return hc;
}

//Meta data of modules
@NgModule({
  declarations: [graphs],
  imports: [
    CommonModule,
    ChartModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCSHxrflIRZl9HAoTeyzUl47J61hA4B1sE', libraries: ['places']
    })
  ],
  providers: [
    WidgetHelperService, {
      provide: HighchartsStatic,
      useFactory: highchartsFactory
    }],
  exports: [GraphComponent, PublicGraphComponent,SandboxGraphComponent]
})
export class GraphModule { }



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/index.ts